import { render, staticRenderFns } from "./login-template.vue?vue&type=template&id=46572428&"
import script from "./login-template.vue?vue&type=script&lang=ts&"
export * from "./login-template.vue?vue&type=script&lang=ts&"
import style0 from "./login-template.vue?vue&type=style&index=0&id=46572428&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports